// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pGNhh","col":"styles_col__58K1U"};